import { wrap } from "@reatom/core"
import { waitForGachaRevealMedia } from "./gacha-reveal-media"

const WHOOSH_URL = "/gacha-reveal/assets/sfx/whoosh-descent.mp3"
const WHOOSH_SYNC_THRESHOLD_SECONDS = 0.08

let whooshAudio: HTMLAudioElement | null = null

export function getGachaRevealVolume(muted: boolean) {
  return muted ? 0 : 0.5
}

function getWhooshAudio(): HTMLAudioElement | null {
  if (typeof window === "undefined") return null

  if (!whooshAudio) {
    whooshAudio = new Audio(WHOOSH_URL)
    whooshAudio.preload = "auto"
    whooshAudio.load()
  }

  return whooshAudio
}

export function preloadGachaRevealWhoosh() {
  getWhooshAudio()
}

export async function waitForGachaRevealWhoosh(signal: AbortSignal) {
  const audio = getWhooshAudio()
  if (audio) await wrap(waitForGachaRevealMedia(audio, signal))
}

function setWhooshPlaybackTime(audio: HTMLAudioElement, currentTime: number) {
  if (
    Number.isFinite(audio.duration) &&
    audio.duration > 0 &&
    currentTime >= audio.duration
  ) {
    audio.pause()
    return false
  }

  if (
    Math.abs(audio.currentTime - currentTime) >= WHOOSH_SYNC_THRESHOLD_SECONDS
  ) {
    audio.currentTime = Math.max(0, currentTime)
  }
  return true
}

export function playGachaRevealWhooshAt(currentTime: number, muted = false) {
  const audio = getWhooshAudio()
  if (!audio) return

  audio.pause()
  audio.volume = getGachaRevealVolume(muted)
  if (!setWhooshPlaybackTime(audio, currentTime)) return
  audio.currentTime = Math.max(0, currentTime)

  void wrap(audio.play()).catch(
    wrap(() => {
      // Browser autoplay policy can still block this if the gesture chain is lost.
    }),
  )
}

export function playGachaRevealWhoosh(muted = false) {
  playGachaRevealWhooshAt(0, muted)
}

export function syncGachaRevealWhooshToPlayback(
  currentTime: number,
  muted = false,
) {
  const audio = getWhooshAudio()
  if (!audio || audio.paused) return

  audio.volume = getGachaRevealVolume(muted)
  setWhooshPlaybackTime(audio, currentTime)
}

export function pauseGachaRevealWhoosh() {
  getWhooshAudio()?.pause()
}

export function setGachaRevealWhooshMuted(muted: boolean) {
  const audio = getWhooshAudio()
  if (!audio) return

  audio.volume = getGachaRevealVolume(muted)
}
